import { render, staticRenderFns } from "./MailOfferDialog.vue?vue&type=template&id=562552ee"
import script from "./MailOfferDialog.vue?vue&type=script&lang=js"
export * from "./MailOfferDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports